const EmptyPlaceholderPage = () => (
    <div className="page">
        <p className="no-information">
            There is no currently any lunch information.
        </p>
    </div>
);

export default EmptyPlaceholderPage;
